export { ErrorComponent } from './error.component';
export { ErrorModule } from "./error.module";
